import "./Settings.css";
import Header from "../header/Header";
import Footer from "../Footer/Footer";
import { useEffect, useState } from 'react';
import Appconfig from '../../config/config';
import { useNavigate } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import Helper from "../../helper";
import ExposureHeader from '../ExposureHeader/ExposureHeader';

function Settings() {
  const userInfo = Helper();
  const navigate = useNavigate();
  const [chipList, setChipList] = useState([]);

  useEffect(() => {
    getChips();
  }, []);

  const getChips = async () => {
    const data = JSON.stringify({
      user_id: userInfo._id,
      master_id: userInfo?.master_id
    });

    const config = {
      method: 'post',
      url: `${Appconfig.apiUrl}chips/getChips`,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    };

    axios(config)
      .then(response => {
        try {
          setChipList(response.data.resultData);
        } catch (e) {
          console.log("Parse error:", e);
        }
      })
      .catch(error => console.log(error));
  };

  const handleInputChange = (event) => {
    const index = event.target.getAttribute('data-id');
    const updatedList = [...chipList];
    updatedList[index]["chip_value"] = parseFloat(event.target.value || 0);
    setChipList(updatedList);
  };

  const addChips = () => {
    const newData = chipList.map((chip) => ({
      user_id: userInfo._id,
      chip_label: String(chip.chip_value),
      chip_value: chip.chip_value
    }));

    const data = JSON.stringify({
      data: newData,
      user_id: userInfo._id
    });

    const config = {
      method: 'post',
      url: `${Appconfig.apiUrl}chips/addMultipleChips`,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    };

    axios(config)
      .then(response => {
        if (response.data.ok) {
          NotificationManager.success('Stake Update Successfully!', '', 3000);
          getChips();
          setTimeout(() => navigate('/'), 2000);
        }
      })
      .catch(error => console.log(error));
  };

  return (
    <>
      {/* <Header />
      <ExposureHeader /> */}

      <div className="p-3 w-full space-y-2 md:mt-0 rounded-lg bg-bg_color_primary shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px]">

        <div className="w-full">
          <span className="text-base text-text_color_primary1 font-lato font-semibold px-1">Edit Stakes</span>
        </div>

        <div className="grid grid-cols-3 gap-2 w-full">
          {chipList.map((chip, index) => (
            <div key={index} className="bg-bg_color_input_bg">
              <input
                type="number"
                pattern="[0-9]*"
                data-id={index}
                value={chip.chip_value}
                onChange={handleInputChange}
                id={`stakeEdit_8${chip._id}`}
                className="rounded h-10 px-3 w-full text-center text-base text-text_color_primary1 font-lato border border-border_color_primary shadow-sm bg-transparent"
              />
            </div>
          ))}
        </div>

        <div className="w-full flex items-center justify-center">
          <button
            onClick={addChips}
            className="flex items-center justify-center gap-1 p-2 bg-bg_color_success mt-2 w-full sm:max-w-[350px] rounded font-semibold text-text_color_primary2 disabled:opacity-80"
          >
            Save
          </button>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
}

export default Settings;
